import { get } from "lodash";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "shared/components/Header";
import ProcessStepper from "shared/components/ProcessStepper";
import { NAME_SPACES } from "shared/locales/constants";
import { ACORIS_SOCIAL_REGIMES } from "utils/constants";
import { STEP_INDEXES } from "../constants";
import {
  demographicsFromFields,
  departmentFromZipCode,
  fieldsFromDemographics,
} from "../helpers";
import View from "./View";

const Demographics = ({ project, onNext, onBack }) => {
  const [nextLoading, setNextLoading] = useState(false);
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const TRANSLATION = t("DETAIL.TEMPLATES.ACORIS_COLLECTIVE", {
    returnObjects: true,
  });

  const department = departmentFromZipCode(
    get(project, "fields.company.zipCode"),
  );

  const [initialValues] = useState(() => ({
    demographics: {
      category: null,
      headcount: null,
      regime: ACORIS_SOCIAL_REGIMES.SECURITE_SOCIALE,
      effectiveDate: null,
      averageAge: null,
      ...demographicsFromFields(get(project, "fields", {})),
      department,
    },
  }));

  const onSubmit = ({ demographics }) => {
    setNextLoading(true);
    onNext({
      payload: {
        fields: {
          ...get(project, "fields", {}),
          ...fieldsFromDemographics(demographics),
        },
      },
      onCompleted: () => setNextLoading(false),
    });
  };

  const steps = useMemo(
    () => Object.values(TRANSLATION.STEPS).map((title) => ({ title })),
    [TRANSLATION],
  );

  return (
    <>
      <Header
        key="header"
        title={TRANSLATION.DEMOGRAPHICS.TITLE}
        subtitle={TRANSLATION.DEMOGRAPHICS.SUBTITLE}
        actions={[]}
      />
      <ProcessStepper
        steps={steps}
        current={STEP_INDEXES.DEMOGRAPHICS}
        aria-label={TRANSLATION.STEPPER_LABEL}
      />
      <View
        translation={TRANSLATION}
        initialValues={initialValues}
        onSubmit={onSubmit}
        onBack={onBack}
        nextLoading={nextLoading}
        disabled={get(project, "expired") || get(project, "locked")}
      />
    </>
  );
};

export default Demographics;
